import {all, fork} from "redux-saga/effects";
import supplierSaga from "@sagas/supplier";
import tagsSaga from "@sagas/tags";
import categorySaga from "@sagas/categories";
import peopleSaga from "@sagas/people";
import imageSaga from "@sagas/image";
import personRolesSaga from "@sagas/person-role";
import userRolesSaga from "@sagas/user-role";
import resourcesSaga from "@sagas/resources";
import menusSaga from "@sagas/menus";
import videoContentsSaga from "@sagas/videoContents";
import videoFilesSaga from "@sagas/videoFiles";
import widgetsSaga from "@sagas/widget";
import usersSaga from "@sagas/users";
import authSaga from "@sagas/auth";
import provinceSaga from "@sagas/province";
import citySaga from "@sagas/cities";
import jobSaga from "@sagas/job";
import hyperLinkMenuSaga from "@sagas/hyperLinkMenu";
import commentsSaga from "@sagas/comments";
import aliasesSaga from "@sagas/aliases";
import ticketsSaga from "@sagas/tickets";
import draftsPeopleSaga from "@sagas/draftsPeople";
import quizzesSaga from "@sagas/quiz";
import trackerPoliciesSaga from "@sagas/trackerPolicy";
import clientSaga from "@sagas/client";

export default function* rootSaga() {
    yield all([
        fork(tagsSaga),
        fork(supplierSaga),
        fork(categorySaga),
        fork(peopleSaga),
        fork(imageSaga),
        fork(personRolesSaga),
        fork(userRolesSaga),
        fork(resourcesSaga),
        fork(menusSaga),
        fork(videoContentsSaga),
        fork(videoFilesSaga),
        fork(widgetsSaga),
        fork(usersSaga),
        fork(authSaga),
        fork(provinceSaga),
        fork(citySaga),
        fork(jobSaga),
        fork(hyperLinkMenuSaga),
        fork(commentsSaga),
        fork(aliasesSaga),
        fork(ticketsSaga),
        fork(draftsPeopleSaga),
        fork(quizzesSaga),
        fork(trackerPoliciesSaga),
        fork(clientSaga),
    ]);
}
